import { useCallback } from 'react';
import { sensorStreamKeysForPorts } from '../../../utils/electronicsDashboardUtils';
import type { PersistDashboardWidgetContentPatch } from './usePersistDashboardWidgetContent';

type SensorStreamPortsPatch = Pick<PersistDashboardWidgetContentPatch, 'sensorKeys' | 'selectedSensorPorts' | 'sensorClassName'>;

/** Persists sensor stream keys and selected ports when the user changes sensors in a toolbar. */
export function useSensorStreamPortsChange({
  dataKey,
  persistWidgetContent,
  sensorClassName,
}: {
  dataKey: string;
  persistWidgetContent: (patch: SensorStreamPortsPatch) => void;
  sensorClassName: string | null;
}) {
  return useCallback(
    (ports: number[]) => {
      persistWidgetContent({
        sensorKeys: sensorStreamKeysForPorts(dataKey, ports),
        selectedSensorPorts: ports,
        ...(sensorClassName ? { sensorClassName } : {}),
      });
    },
    [dataKey, persistWidgetContent, sensorClassName]
  );
}
